import React, { createContext, useContext, useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectTenant } from '../store/slices/authSlice'
import api from '../services/api'

const TenantContext = createContext(null)

export const useTenant = () => {
  const ctx = useContext(TenantContext)
  if (!ctx) {
    throw new Error('useTenant must be used within a TenantProvider')
  }
  return ctx
}

export const TenantProvider = ({ children }) => {
  const { slug } = useParams()
  const tenantFromAuth = useSelector(selectTenant)
  const [tenantInfo, setTenantInfo] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    // If we have tenant from auth and it matches the slug, use it
    if (tenantFromAuth && tenantFromAuth.slug === slug) {
      setTenantInfo(tenantFromAuth)
      return
    }

    // Otherwise fetch public tenant info by slug
    if (slug) {
      setLoading(true)
      api.get(`/tenants/info/${slug}`)
        .then(res => {
          setTenantInfo(res.data.data)
          setError(null)
        })
        .catch(err => {
          console.error('Error fetching tenant info:', err)
          setError('Compañía no encontrada')
          setTenantInfo(null)
        })
        .finally(() => setLoading(false))
    }
  }, [slug, tenantFromAuth])

  const value = {
    tenant: tenantInfo,
    slug,
    loading,
    error,
    nombre: tenantInfo?.nombre || '',
    logoUrl: tenantInfo?.logoUrl || null,
  }

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  )
}

export default TenantContext
